import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter)

// 路由匹配
const routes = [
    {
        path: '/',
        name: 'login',
        component: () => import('../components/Login.vue')
    },
    {
        path: '/main',
        redirect: '/main/home'
    },
    {
        path: '/main',
        name: 'main',
        component: () => import('../components/Main.vue'),
        children: [
            {
                path: 'home',
                name: 'home',
                component: () => import('../views/home.vue')
            },
            {
                path: 'Match',
                name: 'Match',
                component: () => import('../views/Match.vue')
            },
            {
                path: 'Cash',
                name: 'Cash',
                component: () => import('../views/Cash.vue')
            },
            {
                path: 'SciencePopularization',
                name: 'SciencePopularization',
                component: () => import('../views/SciencePopularization.vue')
            },
            {
                path: 'History',
                name: 'History',
                component: () => import('../views/History.vue')
            },
            {
                path: 'Announcement',
                name: 'Announcement',
                component: () => import('../views/Announcement.vue')
            },
            {
                path: 'Notice',
                name: 'Notice',
                component: () => import('../views/Notice.vue')
            },
            {
                path: 'Guide',
                name: 'Guide',
                component: () => import('../views/Guide.vue')
            },
            {
                path: 'question',
                name: 'question',
                component: () => import('../views/question.vue')
            },
            {
                path: 'record',
                name: 'record',
                component: () => import('../views/record.vue')
            },
            {
                path: 'BookPurchase',
                name: 'BookPurchase',
                component: () => import('../views/BookPurchase.vue')
            },
            {
                path: 'ConsultationHotline',
                name: 'ConsultationHotline',
                component: () => import('../views/ConsultationHotline.vue')
            },
            {
                path: 'institution',
                name: 'institution',
                component: () => import('../views/institution.vue')
            },
            {
                path: 'commercialBank',
                name: 'commercialBank',
                component: () => import('../views/commercialBank.vue')
            },
            {
                path: 'outlets',
                name: 'outlets',
                component: () => import('../views/outlets.vue')
            },
            {
                path: 'police',
                name: 'police',
                component: () => import('../views/police.vue')
            },
            {
                path: 'PeopleAdmin',
                name: 'PeopleAdmin',
                component: () => import('../views/PeopleAdmin.vue')
            },
            {
                path: 'CommercialAdmin',
                name: 'CommercialAdmin',
                component: () => import('../views/CommercialAdmin.vue')
            },
            {
                path: 'editPassword',
                name: 'editPassword',
                component: () => import('../views/editPassword.vue')
            },
        ]
    },
]
export const router = new VueRouter({
    mode: 'history',
    routes: routes,
    base: '/'
})
// 全局前置路由导航守卫
// router.beforeEach((to, from, next) => {
//     // 在未登陆状态时不允许进入非登陆注册页面
//     if (!localStorage.getItem('token') && to.name != 'login' ) {
//         next('/')
//     }
//     // 在已登陆状态时，不允许进入登录注册页面
//     else if (localStorage.getItem('token') && to.name == 'login') {
//         next('/main')
//     }
//     // 允许跳转
//     else {
//         next()
//     }
// })

export default router